const createCustomPropType = propTypeFunc => {
  const createWithRequired = isRequired => (props, propName, componentName) => {
    const prop = props[propName];

    if (prop == null && isRequired) {
      return new Error(`Failed prop type: The prop \`${propName}\` is marked as required in  \`${componentName}\`, but its value is \`${prop}\`.`);
    }

    return propTypeFunc(props, propName, componentName);
  };

  const propType = createWithRequired(false);
  propType.isRequired = createWithRequired(true);
  return propType;
}; // eslint-disable-next-line import/prefer-default-export


export const numberHigherThan = minimum => createCustomPropType((props, propName) => {
  // eslint-disable-next-line react/destructuring-assignment
  const prop = props[propName];

  if (prop !== undefined && (typeof prop !== 'number' || prop < minimum)) {
    return new Error(`Failed prop type: The prop \`${propName}\` expects a number higher than \`${minimum}\`, but its value is \`${prop}\` of type \`${typeof prop}\`.`);
  }

  return null;
});